import r from "./index.es262.js";
import e from "./index.es263.js";
function m(t) {
  return r(e(t), {
    attribute: !0
  });
}
export {
  m as default
};
//# sourceMappingURL=index.es242.js.map
